<template>
    <div class="row wrap">
        <div class="hr-title-buttons">
            <div class="title">
                {{$t('Pointer')}}
            </div>
            <div class="buttons">
                <btn square v-if="!hasPointer" @click="addPointer()">
                    <tooltip :text="$t('Add pointer')" delay="0.5s" position="left">
                        <i class="fal fa-plus"></i>
                    </tooltip>
                </btn>
                <btn square link remove v-if="hasPointer" @click="removePointer">
                    <tooltip :text="$t('Remove pointer')" delay="0.5s" position="left">
                        <i class="fal fa-trash"></i>
                    </tooltip>
                </btn>
            </div>
        </div>
        <div class="row col-12" v-if="hasPointer">
            <div class="col-6">
                <input-text v-model="label.pointer_x_coord" :label="$t('Pointer Coord X')" @change="label.save()"/>
            </div>
            <div class="col-6">
                <input-text v-model="label.pointer_y_coord" :label="$t('Pointer Coord Y')" @change="label.save()"/>
            </div>
        </div>
    </div>
</template>

<script>
import {label} from "@/class/label";
import Btn from "@/modules/buttons/btn";
import InputMedia from "@/modules/input/input-media";
import InputText from "@/modules/input/input-text";
import Tooltip from "@/modules/tooltip";

export default {
    name: "Pointer_Edit",
    components: {Tooltip, Btn, InputMedia, InputText,},
    props:{
        label:{type:Object, default : () => new label()}
    },
    methods:{
        addPointer(){
            this.label.pointer_x_coord = this.label.x_coord;
            this.label.pointer_y_coord = parseFloat(this.label.y_coord) + 100.0;
            
            if(this.label.getObjectType() === "overlay"){
                this.label.pointer_x_coord = this.label.x_coord + this.label.width / 2
                this.label.pointer_y_coord = this.label.y_coord + this.label.height + 100
            }
            
            this.label.save();
        },
        removePointer(){
            this.label.pointer_x_coord = 0;
            this.label.pointer_y_coord = 0;
            
            this.label.save();
        }
    },
    computed:{
        hasPointer(){
            return this.label.pointer_x_coord != 0 && this.label.pointer_y_coord != 0
        }
    }
}
</script>
